import React, { useCallback } from 'react';
import OutlineMapIcon from '@src/assets/icons/outline-map.svg?react';
import NotificationIcon from '@src/assets/icons/notification.svg?react';
import styles from './SchoolNewYearModal.module.scss';
import Modal from '@components/modal/Modal';
import Button from '@components/button/Button';
import { useMarkSchoolNewYearModalShownMutation, useMeLazyQuery } from '@src/api/graphql-codegen';

type Props = {
  open: boolean;
  schoolYearKey?: string;
  onClose: () => void;
  onOkAction: () => void;
};

function SchoolNewYearModal(props: Props) {
  const { open, schoolYearKey, onClose, onOkAction } = props;
  const [getUser] = useMeLazyQuery();
  const [markSchoolNewYear, { loading }] = useMarkSchoolNewYearModalShownMutation();

  const handleActionClick = useCallback(
    async (isOK = false) => {
      const key =
        schoolYearKey ?? String(new Date().getFullYear());
      try {
        const { data } = await markSchoolNewYear({
          variables: {
            input: { schoolNewYearInfo: JSON.stringify({ [key]: true }) },
          },
        });
        if (data?.markSchoolNewYearModalShown) {
          await getUser({ fetchPolicy: 'network-only' });
        }
      } finally {
        if (isOK) {
          onOkAction();
        } else {
          onClose();
        }
      }
    },
    [schoolYearKey, markSchoolNewYear, getUser, onClose, onOkAction]
  );

  return (
    <Modal open={!!open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <OutlineMapIcon style={{ marginLeft: '-21px' }} />
        <div className={styles.title}>It's a new school year!</div>
        <div className={styles.detail}>
          We recommend <span style={{ fontWeight: 600 }}>resetting</span> your In Progress and Completed lessons from last year. You can do this in your <span className={styles.highlight}>View Lesson Progress</span> page.
        </div>
          <div className={styles.content}>
            <div className={styles.action}>
                <Button size='small' className={styles.cancelButton} disabled={loading} onClick={() => handleActionClick()} label="NO THANKS" rightIcon={<NotificationIcon style={{ marginLeft: '5px' }} />} />
                <Button size='small' className={styles.actionButton} disabled={loading} onClick={() => handleActionClick(true)} label="VIEW LESSON PROGRESS" />
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default SchoolNewYearModal;
